import { render, staticRenderFns } from "./ReInfo.vue?vue&type=template&id=52845087&scoped=true"
import script from "./ReInfo.vue?vue&type=script&lang=js"
export * from "./ReInfo.vue?vue&type=script&lang=js"
import style0 from "./ReInfo.vue?vue&type=style&index=0&id=52845087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52845087",
  null
  
)

export default component.exports